var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteBase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-2 -2 17 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.9634286,1.09333333 L15.9634286,3.33333333 L-9.68114477e-14,3.33333333 L-9.68114477e-14,1.09333333 L3.97714286,1.09333333 L5.15657143,0 L10.8342857,0 L12.0137143,1.09333333 L15.9634286,1.09333333 Z M1.12457143,17.76 L1.12457143,4.42666667 L14.8388571,4.42666667 L14.8388571,17.76 C14.8388571,18.3644475 14.610288,18.8888867 14.1531429,19.3333333 C13.6959977,19.77778 13.1565745,20 12.5348571,20 L3.42857143,20 C2.80685403,20 2.26743086,19.77778 1.81028571,19.3333333 C1.35314057,18.8888867 1.12457143,18.3644475 1.12457143,17.76 Z",
    id: "\\uE8D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBase);
export default __webpack_public_path__ + "static/media/delete_base.bc2ac9c577a67d63940a0b40b7c9839b.svg";
export { ForwardRef as ReactComponent };